import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="console-a"
            d="M1.15725038,12.2240424 L5.76827428,8.32019979 C5.97861308,8.14212013 5.97914095,7.85832678 5.76827428,7.67980021 L1.15725038,3.77595763 C0.947583206,3.59844659 0.947583206,3.31064432 1.15725038,3.13313328 C1.36691756,2.95562224 1.70685522,2.95562224 1.9165224,3.13313328 L6.52754629,7.03697586 C7.15828357,7.57097853 7.15668506,8.43037482 6.52754629,8.96302414 L1.9165224,12.8668667 C1.70685522,13.0443778 1.36691756,13.0443778 1.15725038,12.8668667 C0.947583206,12.6893557 0.947583206,12.4015534 1.15725038,12.2240424 Z M9,12 L15,12 L15,13 L9,13 L9,12 Z"/>
    </defs>
    <g>
      <use fillRule="nonzero" xlinkHref="#console-a"/>
    </g>
  </svg>
);
